import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'selectric';
import '../../../../@infinite/scripts/vendor/toastr';

import '../../styles/theme.scss';

import $ from 'jquery';
import _ from 'lodash-es';
import { cookiesEnabled } from '@shopify/theme-cart';
import { wrapTable, wrapIframe } from '@shopify/theme-rte';

import sections from '@shopify/theme-sections';
import '../sections/product';


import * as Infinite from '../infinite-loader';

import productArticle from '../components/productArticle';
import productStickyCart from '../components/productStickyCart';
import productBounceArrow from '../components/productBounceArrow';
import collectionFilter from '../components/collectionFilter';
import faq from '../components/faq';
import aboutNav from '../components/aboutNav';
import LanguageMenu from '../components/LanguageMenu';
import RegionRedirect from '../components/RegionRedirect';
import HardRedirectNotification from '../components/HardRedirectNotification';
import PromoCarousel from '../components/PromoCarousel';
import PromoBar from '../components/PromoBar';
import CollectionFilter from '../components/CollectionFilters';
import Blog from '../components/Blog';
import ProductOverview from '../components/ProductOverview';
import cart from '../components/cart';
import initProductReviews from '../components/initProductReviews';
import sliderCart from '../components/sliderCart';

// import sca_locator from '../components/sca.storelocator_scripttag';

// Wordpress modules
import HeroImageGallery from '../components/HeroImageGallery';
import ImageGallery from '../components/ImageGallery';
import RteAccordion from '../components/RteAccordion/index';
import RteHeroEvent from '../components/RteHeroEvent';
import RteCollectionCarousel from '../components/RteCollectionCarousel';
import RteOffsetCaptions from '../components/RteOffsetCaptions';
import RteFeaturedArticles from '../components/RteFeaturedArticles';
import RteFullCaption from '../components/RteFullCaption';
import RteSplitCaption from '../components/RteSplitCaption';
import ShoppableImage from '../components/ShoppableImage';
import RteBanner from '../components/RteBanner';
import RteExternalPods from '../components/RteExternalPods';
import RteButtons from '../components/RteButtons';
import RteLookbookGallery from '../components/RteLookbookGallery';
import RteHeroBlogCarousel from '../components/RteHeroBlogCarousel';
import RteStaggeredArticles from '../components/RteStaggeredArticles';
import RteSectionContainer from '../components/RteSectionContainer';
import RteCollectionGrid from '../components/RteCollectionGrid';
import VideoPlayer from '../sections/VideoPlayer/index';

// *** Auto-generated imports will be placed below. DO NOT EDIT THIS LINE! ***
import FAQ from '../sections/FAQ/index';

window.slate = window.slate || {};
window.theme = window.theme || {};
window.$ = $;
window.jQuery = $;

$(document).ready(() => {
  sections.load(['product']);

  _.each(Infinite, (component) => {
    component();
  });

  productArticle();
  productStickyCart();
  productBounceArrow();
  collectionFilter();
  faq();
  aboutNav();
  LanguageMenu();
  RegionRedirect();
  HardRedirectNotification();
  PromoCarousel();
  PromoBar();
  ProductOverview();
  CollectionFilter();
  Blog();
  cart();
  initProductReviews();
  sliderCart();

  // Store Locator
  // sca_locator();

  // Wordpress modules
  RteAccordion();
  RteHeroEvent();
  RteCollectionCarousel();
  RteOffsetCaptions();
  RteFeaturedArticles();
  RteFullCaption();
  RteSplitCaption();
  ShoppableImage();
  RteBanner();
  RteExternalPods();
  RteButtons();
  RteLookbookGallery();
  RteHeroBlogCarousel();
  RteStaggeredArticles();
  RteSectionContainer();
  RteCollectionGrid();
  HeroImageGallery();
  ImageGallery();
  VideoPlayer();

  // *** Auto-generated imports will be executed below. DO NOT EDIT THIS LINE! ***
  FAQ();
  

  // Fire resize and scroll on page load and section load
  $(window).trigger('resize');
  $(window).trigger('scroll');

  $(document).on('shopify:section:load', () => {
    $(window).trigger('scroll');
    $(window).trigger('resize');
  });

  $('.ProductStars').bind('DOMSubtreeModified', _.debounce(() => {
    $(window).trigger('resize');
    $(window).trigger('breakpointChange');
  }, 500));

  // Init selectric
  $('select').not('[data-no-selectric], [data-no-selectric] select').selectric();

  // Target tables to make them scrollable
  const tableSelectors = '.rte table';

  wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  const iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  // Should probably move this later...doesn't really belong here, but neither does Shopify's stuff above this
  $(document).on('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'INF-ArticleContent' || e.detail.sectionId === 'INF-PageContent') {
      wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper',
      });
    }
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies',
    );
  }
});
 